import {Module} from "vuex";

const state = () => ({
    ids: []
});

const getters = {
    getItenary(state: any) {
        return state.ids;
    }
};
const actions = {
    addToItenary(context, id) {
        const itenary = context.state.ids;
        itenary.push(id)
        context.commit('saveItenary', itenary);
    },
    removeFromItenary(context, id) {
        const itenary = context.state.ids;
        const index = itenary.indexOf(id);
        itenary.splice(index, 1)
        context.commit('saveItenary', itenary);
    }
};
const mutations = {
    saveItenary(state: any, payload: any) {
        state.ids = payload;
        localStorage.setItem('itenaryIds',JSON.stringify(state.ids))
    }
};

export const itenary: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}